/**
 * 出入金状态枚举
 */
export const fundStatusMap = {
  PND: '待提交',
  ACK: '已确认',
  PTC: '待取消',
  APV: '已审批',
  APPROVING: '风控审核中',
  REJ: '已拒绝',
  CAN: '已取消',
  CLS: '已完成',
};

/**
 * 支付类型
 */
export const payMethodsMap = {
  eBanking: '网银',
  ATMandCounter: 'ATM',
  Cheque: '支票',
};
